import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery'; 

@Component({
  selector: 'slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {

  constructor() { }

  ngOnInit() 
  {

    function progressBar()
    {
      setTimeout(function(){
         document.getElementById("progressBar").style.width = "0" ;
      },1000);

      setTimeout(function(){
        document.getElementById("progressBar").style.width = "20%" ;
     },1400);

     setTimeout(function(){
          document.getElementById("progressBar").style.width = "40%" ;
      },1800);

      setTimeout(function(){
        document.getElementById("progressBar").style.width = "60%" ;
      },2200);

      setTimeout(function(){
        document.getElementById("progressBar").style.width = "80%" ;
        },2600);

      setTimeout(function(){
        document.getElementById("progressBar").style.width = "100%" ;
      },3000);

    }
    function resetProgress()
    {
      setTimeout(function(){
        document.getElementById("progressBar").style.width = "0" ;
      },4000);
    }
    /*******************************************slider ********************* */
    function mySlider()
    {
        var back1 = document.getElementById("back1") ; 
        var conback1 = document.getElementById("conback1"); 
        var back2 = document.getElementById("back2") ; 
        var conback2 = document.getElementById("conback2"); 
        var back3 = document.getElementById("back3") ;
        var conback3 = document.getElementById("conback3"); 
        

        back2.style.display = "none" ;
        back3.style.display = "none";
        back1.style.display = "none";
        conback1.style.display = "none"; 
        conback2.style.display = "none"; 
        conback3.style.display = "none";
        setTimeout(function(){
          back2.style.display = "none" ;
          back3.style.display = "none";
          back1.style.display = "block";
          conback1.style.display = "block"; 
          conback2.style.display = "none"; 
          conback3.style.display = "none"; 
          back1.classList.add('animated', 'fadeInRight') ;
          conback1.classList.add("animated" , "fadeInLeft" , "delay-1s" ) 
        } , 0) ; 
        
        setTimeout(function(){
          back1.style.display = "none" ;
          back3.style.display = "none";
          back2.style.display = "block"; 
          conback2.style.display = "block"; 
          conback3.style.display = "none"; 
          conback1.style.display = "none"; 
          back2.classList.add('animated', 'fadeIn')
          conback2.classList.add("animated" , "fadeInRight" , "delay-1s" ) 
        } , 5000) ; 

        setTimeout(function(){
          back1.style.display = "none" ;
          back2.style.display = "none";
          back3.style.display = "block"; 
          conback3.style.display = "block"; 
          conback2.style.display = "none"; 
          conback1.style.display = "none"; 
          back3.classList.add('animated', 'fadeInDownBig')
          conback3.classList.add("animated" , "fadeInUp" , "delay-1s" ) 
        } , 10000) ; 

    }
    progressBar()
    mySlider()
    resetProgress()
    setInterval(progressBar,4000);
    setInterval(resetProgress,5000);
    setInterval(mySlider , 15000);
}}
